// Copyright (c) 2017 Deere & Company

import {isNotNull} from '../../../claim/shared/services/claim-shared-helper';

export const getDateRangeQueryString = (fromDate, toDate) => {

    let dateQueryString;

    dateQueryString = '';

    if (isNotNull(fromDate) && !isNotNull(toDate)) {

        dateQueryString = `&createdDateFrom=${fromDate}`;

    }

    if (!isNotNull(fromDate) && isNotNull(toDate)) {

        dateQueryString = `&createdDateTo=${toDate}`;

    }

    if (isNotNull(fromDate) && isNotNull(toDate)) {

        dateQueryString = `&createdDateFrom=${fromDate}&createdDateTo=${toDate}`;

    }

    return dateQueryString;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/report-services/get-date-range-query-string.js